/**
 * Politica de reconexao do webphone (issue #490).
 *
 * O SIP.js NAO reconecta o transporte sozinho. Ate aqui, quando o WebSocket
 * caia, o hook apenas avisava "Conexão do telefone perdida. Reconecte." e
 * esperava o agente apertar F5 — e enquanto ele nao apertasse, o Asterisk ficava
 * sem contato no AOR e a fila **pulava o agente em silencio**. Medido na Minas
 * Telecom em 12/09/2026: de 903 posicoes de membro em 57 ligacoes, so 126 (14,0%)
 * receberam INVITE; 8 estavam em ligacao e ~25 pausados — o resto era ramal sem
 * registro. Tres ligacoes seguidas na fila `comercial` (13:39, 13:41, 13:43) nao
 * tocaram para NINGUEM.
 *
 * Por isso o backoff comeca curto (1s): o objetivo e o ramal voltar a receber
 * ligacao antes da proxima da fila, nao poupar o servidor. O teto existe pro
 * caso de o motor estar fora do ar — ai insistir de segundo em segundo, vezes
 * ~90 agentes, viraria um problema novo.
 */

/** Atraso da 1a tentativa. Curto de proposito — ver nota acima. */
export const RECONEXAO_BASE_MS = 1_000;
/** Teto do intervalo: motor fora do ar nao vira martelo de N agentes. */
export const RECONEXAO_TETO_MS = 30_000;
/** Fracao de jitter (+/-), pra ~90 webphones nao reconectarem no mesmo instante. */
export const RECONEXAO_JITTER = 0.3;

/**
 * Atraso, em ms, antes da `tentativa`-esima reconexao (1 = primeira).
 *
 * Dobra a cada tentativa ate o teto e aplica jitter de +/-30%. O jitter e o que
 * evita o rebanho: numa queda de rede do escritorio, todos os webphones caem no
 * mesmo segundo e voltariam juntos, batendo no motor em rajada.
 *
 * @param aleatorio injetavel pra teste; espera-se algo em [0,1).
 */
export function atrasoReconexao(tentativa: number, aleatorio: () => number = Math.random): number {
  // Math.max(1, Math.floor(NaN)) e NaN — precisa do guarda antes, senao o atraso
  // vira NaN e o setTimeout dispara imediato, em laco.
  const n = Number.isFinite(tentativa) ? Math.max(1, Math.floor(tentativa)) : 1;
  // 2^(n-1) satura rapido; Math.min antes da potencia evita Infinity com n grande.
  const expoente = Math.min(n - 1, 20);
  const base = Math.min(RECONEXAO_BASE_MS * 2 ** expoente, RECONEXAO_TETO_MS);
  const desvio = base * RECONEXAO_JITTER * (aleatorio() * 2 - 1);
  return Math.max(0, Math.round(base + desvio));
}
